export const CORE_SERVICES = "CORE_SERVICES";
